import {MISC_KEYS} from "@/api/miscApi";
import {client} from "@/httpClient";
import useRegistrationStore from "@/store/registration";
import useTokenStore from "@/store/token";
import type {TToken} from "@/store/types";
import {useMutation} from "@tanstack/react-query";
import type {AxiosError} from "axios";
import type {AxiosAuthRefreshRequestConfig} from "axios-auth-refresh";
import Cookies from "js-cookie";

export const useLogin = (onError?: (error: AxiosError) => void) => {
  const setAccessToken = useTokenStore(state => state.setAccessToken);
  const setRefreshToken = useTokenStore(state => state.setRefreshToken);
  const reset = useRegistrationStore(state => state.reset);

  const {
    mutate: login,
    mutateAsync: asyncLogin,
    isPending,
  } = useMutation({
    mutationKey: MISC_KEYS.mToken,
    mutationFn: (data: {email: string; password: string}) =>
      client.post<TToken>(MISC_KEYS.mToken[0], data, {skipAuthRefresh: true} as AxiosAuthRefreshRequestConfig),
    onSuccess: response => {
      Cookies.set("isLoggedIn", "true", {expires: 365});
      setAccessToken(response.data.access);
      setRefreshToken(response.data.refresh);
      reset();
    },
    onError,
  });

  return {login, asyncLogin, isPending};
};
